import { store } from '@/redux/lib/configureStore.js';

const setRequestLoaderState = ({ key, isLoading } = {}) => {
  const normalizedKey = String(key || '').trim();

  if (!normalizedKey) {
    return;
  }

  store.dispatch({
    type: 'uiSetRequestLoader',
    payload: {
      key: normalizedKey,
      isLoading: isLoading === true,
      [isLoading === true ? 'loadStart' : 'loadEnd']: new Date().toISOString()
    }
  });
};

export default setRequestLoaderState;
